import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface LiveSessionProgressValue {
  placed: number;
  total: number;
  setProgress: (placed: number, total: number) => void;
  resetProgress: () => void;
}

const LiveSessionProgressContext = createContext<LiveSessionProgressValue | null>(null);

export function LiveSessionProgressProvider({ children }: { children: ReactNode }) {
  const [placed, setPlaced] = useState(0);
  const [total, setTotal] = useState(0);
  const setProgress = useCallback((p: number, t: number) => {
    setPlaced(p);
    setTotal(t);
  }, []);
  const resetProgress = useCallback(() => {
    setPlaced(0);
    setTotal(0);
  }, []);
  return (
    <LiveSessionProgressContext.Provider value={{ placed, total, setProgress, resetProgress }}>
      {children}
    </LiveSessionProgressContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useLiveSessionProgress() {
  return useContext(LiveSessionProgressContext);
}
